// plugins/sentry-api-monitor-runtime.client.ts
import * as Sentry from '@sentry/nuxt'

export default defineNuxtPlugin(() => {
  const nuxtApp = useNuxtApp()
  
  // Hook ke runtime untuk intercept semua $fetch calls
  nuxtApp.hook('app:created', () => {
    // Patch $fetch dari nuxtApp
    if (nuxtApp.$fetch) {
      const originalFetch = nuxtApp.$fetch
      
      nuxtApp.$fetch = new Proxy(originalFetch, {
        apply(target, thisArg, args) {
          const [url, options = {}] = args
          
          // Log request
          console.log('API Request:', { url, options })
          
          // Kirim request ke Sentry
          Sentry.captureMessage(`API Request: ${options.method || 'GET'} ${url}`, {
            level: 'info',
            tags: {
              type: 'api_request',
              method: options.method || 'GET',
              endpoint: url.toString()
            },
            extra: {
              request_details: {
                url: url,
                method: options.method || 'GET',
                headers: options.headers,
                body: options.body,
                timestamp: new Date().toISOString()
              }
            }
          })
          
          // Execute original fetch
          const promise = target.apply(thisArg, args)
          
          return promise
            .then(response => {
              // Log successful response
              console.log('API Response Success:', { url, response })
              
              // Kirim response ke Sentry
              Sentry.captureMessage(`API Response: ${options.method || 'GET'} ${url} - Success`, {
                level: 'info',
                tags: {
                  type: 'api_response',
                  method: options.method || 'GET',
                  endpoint: url.toString(),
                  success: 'true'
                },
                extra: {
                  request_details: {
                    url: url,
                    method: options.method || 'GET',
                    headers: options.headers,
                    body: options.body
                  },
                  response_details: {
                    data: typeof response === 'object' ? JSON.stringify(response) : response,
                    timestamp: new Date().toISOString()
                  }
                }
              })
              
              return response
            })
            .catch(error => {
              // Log error
              console.error('API Error:', { url, error })
              
              // Kirim error ke Sentry
              Sentry.captureException(error, {
                tags: {
                  type: 'api_error',
                  api_endpoint: url.toString(),
                  method: options.method || 'GET'
                },
                extra: {
                  request_details: {
                    url: url,
                    method: options.method || 'GET',
                    headers: options.headers,
                    body: options.body,
                    timestamp: new Date().toISOString()
                  },
                  error_details: {
                    message: error.message,
                    stack: error.stack,
                    status: error.status || error.statusCode,
                    timestamp: new Date().toISOString()
                  }
                }
              })
              
              throw error
            })
        }
      })
    }
  })
})